import { FaInstagram, FaLinkedinIn, FaGithub, FaTwitter,} from "react-icons/fa";
import { RiFacebookFill } from "react-icons/ri";
import {SiLeetcode} from "react-icons/si"

export const data = [
  {
    link: "https://www.instagram.com/0000000_060516_065152_00516500/",
    icon: <FaInstagram />,
  },
  { link: "https://github.com/Nmohd", icon: <FaGithub /> },
  { link: "https://twitter.com/najeebu50", icon: <FaTwitter /> },
  {
    link: "https://www.facebook.com/najeeb.ullah.1069",
    icon: <RiFacebookFill />,
  },
  {
    link: "https://www.linkedin.com/in/najeeb50/",
    icon: <FaLinkedinIn />,
  },
  {
    link: "https://leetcode.com/Najeebu50/",
    icon: <SiLeetcode />,
  },
];
